import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { convertSingleSelectToMultiSelect } from '../filterUtils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Insurance',
  name: 'doctorInsurance',
  type: 'multiSelect',
  selected: null,
  selectedVal: [],
};

const storeName = 'doctorInsurance';
export const useDoctorInsuranceFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateDoctorInsuranceFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'doctorInsurance' });
          convertSingleSelectToMultiSelect(state);
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateDoctorInsuranceFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'doctor_insurance', action: 'select', item_id: value }, '239fb94d-ec8f-42f7-ac21-b842b0f39d5d');
  }

  setFilterValue(useDoctorInsuranceFilter, option);
};
export const clearDoctorInsuranceFilterOption = () =>
  useDoctorInsuranceFilter.setState({ ...initialState }, false, {
    type: 'clearDoctorInsuranceFilterOption',
  });
